<template>
    <div class="map-places-table">
            <v-data-table
              :headers="headers"
              :items="getBuildings"
              items-per-page="25"
              :loading="isBuildingLoading"
              no-data-text = "Žádné údaje"
              class="d-none d-sm-block"
              :sort-by="[{ key: $query.sort, order: $query.order }]"
              @update:sort-by="s => { $query.sort = s[0]?.key; $query.order = s[0]?.order; }"
              v-model.items-per-page="$query.rowsPerPage"
              v-model.page="$query.page"
              :hover="true"
            >
            <template v-slot:item.id="{ item }">
                <span class="pointer" @click="goToDetail(item.id)">{{ item.id }}</span>
            </template>
            <template v-slot:item.name="{ item }">
                <strong class="text-xs-left pointer text-light-green"  @click="goToDetail(item.id)">{{ item.localizedAttributes.cz.name }}</strong>
            </template>
            <template v-slot:item.description="{ item }">
                {{ ellipsis(item.localizedAttributes.cz.description, 60) }}
            </template>
            </v-data-table>

            <!-- ONLY FOR SMALLER SCREENS -->
            <v-data-iterator
                :items="getBuildings"
                :hide-default-footer="true"
                :disable-pagination="true"
                :hide-default-header="false"
                class="d-block d-sm-none"
                :sort-by="[{ key: $query.sort, order: $query.order }]"
                @update:sort-by="s => { $query.sort = s[0]?.key; $query.order = s[0]?.order; }"
                v-model.items-per-page="$query.rowsPerPage"
                v-model.page="$query.page"
            >
                <template v-slot:no-data>
                        Žádná dostupná data
                </template>
                <template v-slot:default="props">
                <v-row>
                <v-col v-for="item in props.items" class="pt-0" :key="item.id" cols="12">
                    <mobile-data-table-row
                        @click="goToDetail(item.raw.id)"
                    >
                        <template v-slot:number>{{ item.raw.id }}</template>
                        <template v-slot:title>{{ item.raw.localizedAttributes?.cz.name }}</template>
                        <template v-slot:subtitle1> {{ item.raw.localizedAttributes?.cz.description }}</template>
                    </mobile-data-table-row>
                </v-col>
                </v-row>
            </template>
        </v-data-iterator>
    </div>
</template>

<script>
    import MobileDataTableRow from '../../components/layout/MobileDataTableRow.vue';

    import {mapActions, mapGetters} from 'vuex';
    import {ellipsis} from "@/filters/ellipsis";
    export default {
        name: "Buildings",

        components: {
            MobileDataTableRow
        },

        data() {
            return {
              headers: [
                  {
                      title: 'Číslo',
                      align: 'left',
                      sortable: true,
                      value: 'id',
                      width: '5%'
                  },
                  {
                      title: 'Název',
                      align: 'left',
                      sortable: true,
                      key: 'name',
                      value: 'localizedAttributes.cz.name',
                      width: '10%'
                  },
                  {
                      title: 'Popis',
                      align: 'left',
                      sortable: true,
                      key: 'description',
                      value: 'localizedAttributes.cz.description',
                      width: '50%'
                  },
              ],
            }
        },

        mounted(){
          if(this.getBuildings.length === 0 ){
            this.fetchAllBuildings();
          }
        },

        computed: {
          ...mapGetters('buildings', ['getBuildings', 'isBuildingLoading']),
        },

        methods: {
            ellipsis,
            ...mapActions('buildings',['fetchAllBuildings','deleteBuilding']),
            
            goToDetail( id ) {
                this.$router.push({name: 'mapDetail', params: {type:"building", id:id}});
            },
        },

    }
</script>

<style scoped>
.map-places-table{
    margin-top:1rem;
    width:100%;
}
.map-places-table a {
    color: rgba(255, 255, 255, 0.75);
    text-decoration: none;
    font-size: 1.2rem;
}

.map-places-table tr {
    cursor: pointer;
}

.map-places-table :deep(.v-progress-linear div) {
    background-color: #7BB916 !important;
}

#deleteCard{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2),
                0px 5px 2px 0px rgba(0, 0, 0, 0.14),
                0px 5px 5px 0px rgba(0, 0, 0, 0.12);
}

.actionsDetails{
    background: rgba(0, 0, 0, 0.45) !important;
    color: white !important;
}

.map-places-table :deep(.v-data-table__checkbox i) {
    color: rgba(0,0,0,.48);
}
</style>
